<template>
    <div>
        <div>
            <!-- <AssignmentPopup :assignedData="requestData"/> -->
            <div>
                <div v-if="popupPartnersManagement">
                    <div class="pop-holder" >
                        <div class="row">
                            <div class="col-md-8">
                                <!-- <h6>1 New Property Assigned</h6> -->
                                <div class="left-hand">
                                    <img src="../assets/icons/request.svg" alt="request">
                                    <div>
                                        <h5>1 New Request</h5>
                                        <h5 v-if="popupPartnersManagement">{{ popupPartnersManagement.property.title }}</h5>
                                        <div class="time-bouund">
                                            <h4 v-if="timeLeftP > 0">{{formattedTimeParnter}} <span>Time Left</span></h4>
                                            <h4 v-else>00:00:00</h4>
                                            <h6>Note that property will be considered rejected when the time elapses</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="responseButton">
                                    <button class="btn accept" ref="btn1" :disbaled="btnLoading.btn1" @click="respondToManagementAssignment('accept', popupPartnersManagement.id, 'btn1')">
                                        <span v-if="!btnLoading.btn1">Accept</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                    <button class="btn reject" ref="btn2" :disbaled="btnLoading.btn2" @click="respondToManagementAssignment('ignore', popupPartnersManagement.id, 'btn2')">
                                        <span v-if="!btnLoading.btn2">Reject</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>

                <!-- <div class="container-fluid"> -->
                    <div class="pop-holder" v-if="requestData.propertyAssign">
                        <div class="row">
                            <div class="col-md-8">
                                <!-- <h6>1 New Property Assigned</h6> -->
                                <div class="left-hand">
                                    <img src="../assets/icons/request.svg" alt="request">
                                    <div>
                                        <h5>1 New Property Assigned</h5>
                                        <h5 v-if="requestData.propertyAssign">{{ requestData.propertyAssign.property.title }}</h5>
                                        <div class="time-bouund">
                                            <h4 v-if="timeLeft2 > 0">{{formattedTime2}} <span>Time Left</span></h4>
                                            <h4 v-else>00:00</h4>
                                            <h6>Note that property will be consider rejected when the time elapses</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="responseButton">
                                    <button class="btn accept" ref="btna" :disbaled="btnLoading.btna" @click="respondToPropertyAssignment('accept', requestData.propertyAssign.id, 'btna')">
                                        <span v-if="!btnLoading.btna">Accept</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                    <button class="btn reject" ref="btnb" :disbaled="btnLoading.btnb" @click="respondToPropertyAssignment('ignore', requestData.propertyAssign.id, 'btnb')">
                                        <span v-if="!btnLoading.btnb">Reject</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pop-holder" v-if="requestData.maintainance">
                        <div class="row">
                            <div class="col-md-8">
                                <!-- <h6>1 New Property Assigned</h6> -->
                                <div class="left-hand">
                                    <img src="../assets/icons/request.svg" alt="request">
                                    <div>
                                        <h5>1 New Property Maintainace Assigned</h5>
                                        <h5 v-if="requestData.maintainance">{{ requestData.maintainance.property.title }}</h5>
                                        <div class="time-bouund">
                                            <h4 v-if="timeLeft3 > 0">{{ formattedTime3 }} <span>Time Left</span></h4>
                                            <h4 v-else>00:00</h4>
                                            <h6>Note that property will be consider rejected when the time elapses</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="responseButton">
                                    <button class="btn accept" ref="btn3" @click="popmaintainancefmio = 1; responseToPropertyMaintainanceFMIO('accept', requestData.maintainance.id, 'btn3')">
                                        <span v-if="!btnLoading.btn3">Accept</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                    <button class="btn reject" ref="btn4" @click="popmaintainancefmio = 1; responseToPropertyMaintainanceFMIO('reject', requestData.maintainance.id, 'btn4')">
                                        <span v-if="!btnLoading.btn4">Reject</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pop-holder" v-if="requestData.fmio">
                        <div class="row">
                            <div class="col-md-8">
                                <!-- <h6>1 New Property Assigned</h6> -->
                                <div class="left-hand">
                                    <img src="../assets/icons/request.svg" alt="request">
                                    <div>
                                        <h5>1 New FM/IO Assigned</h5>
                                        <h5 v-if="requestData.fmio.user">{{ requestData.fmio.user.firstname }} {{ requestData.fmio.user.lastname }}</h5>
                                        <div class="time-bouund">
                                            <h4 v-if="timeLeft > 0">{{ formattedTime }} <span>Time Left</span></h4>
                                            <h4 v-else>00:00</h4>
                                            <h6>Note that property will be consider rejected when the time elapses</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="responseButton">
                                    <button class="btn accept" ref="btn5" @click="popmaintainancefmio = 2; responseToPropertyMaintainanceFMIO('accept', requestData.fmio.id, 'btn5')">
                                        <span v-if="!btnLoading.btn5">Accept</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                    <button class="btn reject" ref="btn6" @click="popmaintainancefmio = 2; responseToPropertyMaintainanceFMIO('reject', requestData.fmio.id, 'btn6')">
                                        <span v-if="!btnLoading.btn6">Reject</span>
                                        <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
            </div>
            <div class="">
                <div class="row">
                    <div class="col-md-8">
                        <DashboardCard @callDasboardSummary="reloadFunc"></DashboardCard>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="card-body">
                                    <h6>Total Earnings</h6>
                                    <h3>₦{{ Number(totalEarnings).toLocaleString() }}</h3>
                                    <div class="card-buttons">
                                        <button disabled class="btn secondary-btn">Revenue Details</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card-body">
                                    <h6 style="cursor: pointer;" @click="moveToPropertyManagement(1)">Properties Managed</h6>
                                    <h3 v-if="dashboardDataGraph">{{ dashboardDataGraph.properties || 0}}</h3>
                                    <!-- <h3>{{ !visibility ? formattedBalance(availableBalance) : '************' }} <span @click="visibility = !visibility" style="margin-left: 10px; font-size: 20px;"><i class="fa fa-eye-slash" :class="[visibility ? 'fa-eye' : 'fa-eye-slash']"></i></span></h3> -->
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <p class="tooltip-container" @click="moveToPropertyManagement(2)">Landlord managed 
                                            <span class="info-icon">!</span>
                                            <span class="tooltip-text">Total number of all the landlord assigned to you that you managed</span>
                                            </p>
                                            <small v-if="dashboardDataGraph">{{ dashboardDataGraph.landlord_count || 0}}</small>
                                        </div>
                                        <div>
                                            <p class="tooltip-container">FM managed 
                                            <span class="info-icon">!</span>
                                            <span class="tooltip-text">Total number of all the FMs assigned to you that you managed</span>
                                            </p>
                                            <small>{{ dashboardDataGraph.fms || 0}}</small>
                                        </div>
                                    </div>
                                   

                                   
                                </div>
                            </div>
                        </div>

                       
                        <div class="bar-chart-holder">
                            <h4>Earnings</h4>
                            <div class="form-group">
                                <select id="vouchertype" class="form-control input-field col-md-2" >
                                    <option selected value="">Monthly</option>
                                    <!-- <option>Yearly</option> -->
                                </select>
                            </div>
                            <hr>
                            <div>
                                <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
                            </div>
                        </div>
                       

                        <div class="requests-holder">
                            
                            <div class="d-flex justify-content-between align-items-baseline">
                                <div class="request-top-text">
                                    <h6>Requests</h6>
                                    <p>Requests are considered rejected after 24hrs without acceptance</p>
                                </div>
                                <h5 class="show-more">Show more</h5>
                            </div>
                            <hr>

                            <div class="request-holder">
                                <div class="request-btns">
                                    <button v-if="inspectionList.length > 0" :disabled="requestLoader2 || requestLoader" class="btn" @click="requestOption = 1" :class="[requestOption == 1 ? 'activeBtnRequest' : '']">Inspection ({{ inspectionList.length }})</button>
                                    <button v-if="managementList.length > 0" :disabled="requestLoader2 || requestLoader" class="btn" :class="[requestOption == 2 ? 'activeBtnRequest' : '']" @click="requestOption = 2">Facility Management ({{managementList.length}})</button>
                                    <button v-if="maintainanceList.length > 0" :disabled="requestLoader2 || requestLoader" class="btn" :class="[requestOption == 3 ? 'activeBtnRequest' : '']" @click="requestOption = 3">Maintainance ({{ maintainanceList.length }})</button>
                                    <button v-if="FmIoList.length > 0" :disabled="requestLoader2 || requestLoader" class="btn" :class="[requestOption == 4 ? 'activeBtnRequest' : '']" @click="requestOption = 4">FM/IO ({{ FmIoList.length }})</button>
                                </div>
                                <hr v-if="loading">
                                <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                                <div v-else>
                                    <div v-if="requestOption == 1">
                                        <div class="request-list" v-for="(item, index) in inspectionList"
                                            :key="index">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="right-request">
                                                        <img src="../assets/icons/request.svg" alt="request">
                                                        <div>
                                                            <h5>Property Inpection Request</h5>
                                                            <h6>{{item.property.address}}</h6>
                                                            <h4>{{ item.remaining }}<span> Time left</span></h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="request-btns-acctions">
                                                        <button :disabled="item.status == 'expired'" class="btn viewBtn" @click="moveToPropertyDetails(item.property.batch)">View</button>
                                                        <button :disabled="requestLoader2 || requestLoader || item.status == 'expired' || item.accepted == 'YES'" class="btn acceptBtn" @click="requestId = item.id; respondToPropertyAssignment('accept', item.id)">
                                                            <span v-if="requestId == item.id && requestLoader"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Accept</span>
                                                           
                                                        </button>
                                                        <button :disabled="requestLoader || requestLoader2 || item.status == 'expired' || item.accepted == 'YES'" class="btn rejectBtn" @click="requestId = item.id; respondToPropertyAssignment('ignore', item.id)">
                                                            <span v-if="requestLoader2 && requestId == item.id"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Reject</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="requestOption == 2">
                                        <div class="request-list" v-for="(item, index) in managementList"
                                            :key="index">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="right-request">
                                                        <img src="../assets/icons/request.svg" alt="request">
                                                        <div>
                                                            <h5>Facility Management Request</h5>
                                                            <h6>{{item.property.address}}</h6>
                                                            <h4>{{ item.remaining }}<span> Time left</span></h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="request-btns-acctions">
                                                        <button :disabled="item.status == 'expired'" class="btn viewBtn" @click="moveToPropertyDetails(item.property.batch)">View</button>
                                                         <button :disabled="requestLoader2 || requestLoader || item.status == 'expired' || item.accepted == 'YES'" class="btn acceptBtn" @click="requestId = item.id; respondToPropertyAssignment('accept', item.id)">
                                                            <span v-if="requestId == item.id && requestLoader"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Accept</span>
                                                           
                                                        </button>
                                                        <button :disabled="requestLoader || requestLoader2 || item.status == 'expired' || item.accepted == 'YES'" class="btn rejectBtn" @click="requestId = item.id; respondToPropertyAssignment('ignore', item.id)">
                                                            <span v-if="requestLoader2 && requestId == item.id"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Reject</span>
                                                        </button>


                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="requestOption == 3">
                                        <div class="request-list" v-for="(item, index) in maintainanceList"
                                            :key="index">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="right-request">
                                                        <img src="../assets/icons/request.svg" alt="request">
                                                        <div>
                                                            <h5>Property Maintainance Request</h5>
                                                            <h6>{{item.property.address}}</h6>
                                                            <h4>{{ item.remaining }}<span> Time left</span></h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="request-btns-acctions">
                                                        <button disabled class="btn viewBtn">View</button>
                                                        <button :disabled="requestLoader2 || requestLoader || item.status == 'expired' || item.accepted == 'YES' || item.approved == '1'" class="btn acceptBtn" @click="requestId = item.id; responseToPropertyMaintainanceFMIO('accept', item.id)">
                                                            <span v-if="requestId == item.id && requestLoader"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Accept</span>
                                                           
                                                        </button>
                                                        <button :disabled="requestLoader || requestLoader2 || item.status == 'expired' || item.accepted == 'YES' || item.approved == '1'" class="btn rejectBtn" @click="requestId = item.id; responseToPropertyMaintainanceFMIO('ignore', item.id)">
                                                            <span v-if="requestLoader2 && requestId == item.id"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Reject</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="requestOption == 4">
                                        <div class="request-list" v-for="(item, index) in FmIoList"
                                            :key="index">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <div class="right-request">
                                                        <img src="../assets/icons/request.svg" alt="request">
                                                        <div>
                                                            <h5>Property Maintainance Request</h5>
                                                            <h6>{{item.user.firstname}} {{item.user.lastname}}</h6>
                                                            <h4>{{ item.remaining }}<span> Time left</span></h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="request-btns-acctions">
                                                        <button disabled class="btn viewBtn">View</button>
                                                        <button :disabled="requestLoader2 || requestLoader || item.approved == '1'" class="btn acceptBtn" @click="requestId = item.id; responseToPropertyMaintainanceFMIO('accept', item.id)">
                                                            <span v-if="requestId == item.id && requestLoader"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Accept</span>
                                                        </button>
                                                        <button :disabled="requestLoader || requestLoader2 || item.approved == '1'" class="btn rejectBtn" @click="requestId = item.id; responseToPropertyMaintainanceFMIO('ignore', item.id)">
                                                            <span v-if="requestLoader2 && requestId == item.id"><i class="fa fa-spinner fa-spin"></i></span>
                                                            <span v-else>Reject</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                    </div>
                    <div class="col-md-4">
                        <div class="notifications-holder">
                            <h5>Notifications (0)</h5>
                            <hr>
                            <div class="d-none">
                                <h5>Notifications (6)</h5>
                                <hr>
                                <div class="notifications">
                                    <h6>Routine facility check completed for sunrise </h6>
                                    <p>30 min ago.</p>
                                    <hr>
                                </div>
                                <div class="notifications">
                                    <h6>Routine facility check completed for sunrise </h6>
                                    <p>30 min ago.</p>
                                    <hr>
                                </div>
                                <!-- <hr> -->
                                <h4 class="show-more text-center">View more...</h4>
                            </div>
                            <div>
                                <EmptyState :emptyData="emptyDataObject" />
                            </div>
                        </div>


                        <div class="notifications-holder">
                            <h5>Available Properties</h5>
                            <hr>
                            <div>

                                <div class="mt-4 inner-carousel" v-if="randomProperties.length > 0">
                                    <div class="inner-slider" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
                                        <div class="property-list" v-for="(item, index) of randomProperties.slice(0, 3)" :key="index">
                                            <div>
                                                <img v-if="item.oneimageurl" style="border-radius: 8px; border: 1px solid #D5D7DA; height: 213px;" class="w-100" :src="item.oneimageurl" alt="img">
                                                <img v-else style="border-radius: 8px; border: 1px solid #D5D7DA;" class="w-100" src="../assets/images/property-img.jpg" alt="img">
                                               
                                            </div>
                                            <div>
                                                <h5 style="font-weight: 500 !important; margin-top: 10px; color: #2B3352 !important; " class="ellipsis">{{ item.title }}</h5>
                                                <h5 style="font-weight: 500 !important; margin-top: 10px; color: #2B3352 !important; ">PIN: {{ item.specific_data.pin }}</h5>
                                                <div class="amount-address">
                                                    <p class="ellipsis"><img src="../assets/icons/location.svg" alt="location">{{ item.specific_data.citty }} {{ item.specific_data.state }}</p>
                                                    <h4>₦{{Number(item.amount).toLocaleString()}}/Annually</h4>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <span style="margin-right: 30px;"><img src="../assets/images/bed.svg" alt="bedroom"> {{ item.specific_data.bedrooms }}</span> <span><img src="../assets/images/bath.svg" alt="bathroom"> {{ item.specific_data.bathrooms }}</span>
                                                    </div>
                                                    <div>
                                                        <button class="btn view-detail-btn" @click="moveToPropertyDetailsOppotunity(item.id)">View Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div @click=navigateToMoreOpp(2)>
                                                <h6>{{ item.title }}</h6>
                                                <p>{{ item.description }}</p>
                                                <h5><span>{{ Number(item.amount).toLocaleString() }}</span>/Annually</h5>
                                            </div> -->
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="slide-button">
                                        <button class="btn" :class="[currentIndex == 0 ? 'active-slide' : '']"></button>
                                        <button class="btn" :class="[currentIndex == 1 ? 'active-slide' : '']"></button>
                                        <button class="btn" :class="[currentIndex == 2 ? 'active-slide' : '']"></button>
                                    </div>
                                </div>
                                <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>


                                

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Activity tracking -->
            <div class="activity-holder">
                <h3 class="overview-text">Activity Tracking</h3>

                <div class="actiivity-buttons-holder">
                    <div v-for="(item, index) in activitybuttons" :key="index">
                        <button :disabled="index != 0" class="btn" :class="[activeBtnIndex === index ? 'activeBtn' : '']" @click="activeBtnIndex = index">{{item.name}}</button>
                        <!-- <button class="btn activeBtn">Complaints</button> -->
                    </div>
                </div>

                <!-- <div class="form-group d-flex justify-content-between">
                    <div class="form-group col-md-6" style="padding-left: 0; padding-right: 0; gap: 10px;">
                        <input class="form-control input-field search" type="text" name="search" id="search" placeholder="Search...">
                    </div>
                    <div class="form-group">
                        <select id="vouchertype" class="form-control input-field" >
                            <option selected value="">Status</option>
                            <option>Resolved</option>
                            <option>Pending</option>
                            <option>Ongoing</option>
                        </select>
                    </div>
                </div> -->
                <div class="table-responsive tableList">
                    <div class="m-auto text-center mt-4" v-if="loadingDashboard"><Loader/></div>
                    <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Full name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Phone number</th>
                                <th scope="col">Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in assingedFMArray"
                                :key="index"
                                :value="item.id">
                                <td>{{index + 1}}</td>
                                <td>{{item.user.firstname}} {{item.user.lastname}}</td>
                                <td>{{item.user.email}}</td>
                                <td>{{item.user.phone}}</td>
                                <td>{{ item.user.address }}</td>
                                <!-- <td>
                                    <img class="dropdown-toggle" style="cursor: pointer;" src="../assets/icons/menu-icon.svg" alt="menu" data-toggle="dropdown" aria-expanded="false">
                                    <div class="dropdown-menu">
                                    <a @click="viewLandlordDetails(item.id)" class="dropdown-item">View details</a>
                                    <a @click="addProperty(item.id)" class="dropdown-item">Add property (unit)</a>
                                    <a class="dropdown-item">Generate report</a>
                                    <a class="dropdown-item">Delete</a>
                                    </div>
                                </td> -->
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="assingedFMArray.length == 0 && !loadingDashboard">
                        <EmptyState :emptyData="emptyDataObject" />
                    </div>
                </div>
            </div>
            <!-- Activity tracking -->
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
// import partners from '../services/partners'
import EmptyState from "../components/EmptyState.vue";
import Loader from '../components/Loader';
// import AssignmentPopup from "../components/AssignmentPopup.vue";
import DashboardCard from "../components/DashboardCard.vue";
import partners from "../services/partners";
// import properties from "../services/properties";
import opportunities from "../services/opportunityDesk";
export default {
    name: "NewDashboard",
    components: {
        apexchart: VueApexCharts,
        EmptyState,
        Loader,
        // AssignmentPopup,
        DashboardCard
    },

    props: {
        // emptyData: {
        //     type: Object,
        //     required: true,
        // }
    },
    data() {
        return {
            loading: false,
            loadingassign: false,
            loadingDashboard: false,
            requestLoader2: false,
            requestLoader: false,
            popmaintainancefmio: null,
            requestId: "",
            btnLoading: {
                btn1: false,
                btn2: false,
                btn3: false,
                btn4: false,
                btn5: false,
                btn6: false,
                btna: false,
                btnb: false,
            },
            currentIndex: 0,
            interval: null,
            userID: "",
            userData: "",
            inspectionList: [],
            partnersManagement: [],
            popupPartnersManagement: '',
            propertySingleRequest: "",
            maintainanceRequest: "",
            fmioRequest: "",
            items: [
                { id: 1, expiry: 1746275300, remaining: '' }
            ],
            maintainanceList: [],
            FmIoList: [],
            managementList: [],
            requestOption: 1,
            // countdownTimestamp: 1744745990 * 1000, // Convert to milliseconds
            timeLeftP: 0,
            timeLeft: 0,
            timeLeft2: 0,
            timeLeft3: 0,
            intervalId: null,
            timer: "",
            timer2: "",
            timer3: "",
            timer4: "",
            totalEarnings: 0,
            requestData: {
                fmio: "",
                propertyAssign: "",
                maintainance: "",
            },
            dashboardDataGraph: "",
            series: [
                {
                    // data: [300, 400, 500, 600, 700, 900], // Data values
                    data: [],
                },
            ],
            chartOptions: {
                chart: {
                type: "bar",
                height: 350,
                },
                plotOptions: {
                    bar: {
                        distributed: true, // Enables distributed bars
                        borderRadius: 5, // Optional: Rounds the corners
                        columnWidth: '90%',
                    },
                },
                // colors: [
                // "#008FFB",
                // "#00E396",
                // "#FEB019",
                // "#FF4560",
                // "#775DD0",
                // "#546E7A",
                // "#26a69a",
                // "#D10CE8",
                // ], // Custom colors per bar

                colors: [
                "#62B2FD",
                "#9BDFC4",
                "#F99BAB",
                "#FFB44F",
                "#9F97F7",
                "#CED6DE",
                "#D10CE8",
                ],
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    labels: {
                        show: false, // Hides x-axis labels
                    },
                categories: [
                    "Smart FM/IO Commission",
                    "State/National Bonus",
                    "Partners Royalties",
                    "Property Management Commission",
                    "Property Sales",
                    "Rent Administration fees",
                    "Subscription"
                ],
                },
            },
            emptyDataObject: {
                header: 'No record found',
                option: 'Record will be displayed when updated or avaialable'
            },
            emptyDataObject2: {
                header: 'No record found',
                option: 'Notifications not available now.'
            },
            activeBtnIndex: 0,
            assingedFMArray: [],
            activitybuttons: [
                {
                    name: "Assigned FM",
                },
                {
                    name: "Due rents",
                },
                {
                    name: "Complaints",
                },
                {
                    name: "Inspections",
                },
                {
                    name: "Maintenance",
                },
            ],
            propItem: [
                {
                title: "3 bedroom fully detached duplex1",
                description: "Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non ...",
                amount: 2000000,
                },
                {
                title: "2 bedroom fully detached duplex2",
                description: "Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non ...",
                amount: 2000000,
                },
                {
                title: "3 bedroom fully detached duplex3",
                description: "Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non ...",
                amount: 2000000,
                }
            ],
            randomProperties: [],
        }
    },
    created() {
        const tokenUser = this.$cookies.get('shelta-c');
        if (tokenUser) {
            // console.log("token user", tokenUser)
            this.$store.dispatch("saveUser", tokenUser);
            this.$store.dispatch("saveSubscription", tokenUser.smartsubscribed);
        }
    },
    computed: {
        formattedTimeParnter() {
            const totalSeconds = Math.floor(this.timeLeftP / 1000);
            // const days = Math.floor(totalSeconds / (3600 * 24));
            const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return `${hours}h : ${minutes}m : ${seconds}s`;
        },
        
        formattedTime() {
            const totalSeconds = Math.floor(this.timeLeft / 1000);
            // const days = Math.floor(totalSeconds / (3600 * 24));
            const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return `${hours}:${minutes}:${seconds}`;
            // return `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
        },
        formattedTime2() {
            const totalSeconds = Math.floor(this.timeLeft2 / 1000);
            // const days = Math.floor(totalSeconds / (3600 * 24));
            const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return `${hours}:${minutes}:${seconds}`;
            // return `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
        },
        formattedTime3() {
            const totalSeconds = Math.floor(this.timeLeft3 / 1000);
            // const days = Math.floor(totalSeconds / (3600 * 24));
            const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return `${hours}:${minutes}:${seconds}`;
            // return `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
        },
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        this.stopAutoSlide();
    },
   
    mounted() {
        const tokenUser = this.$cookies.get('shelta-c');
        if (tokenUser) {
            this.$store.dispatch("saveUser", tokenUser);
            this.$store.dispatch("saveSubscription", tokenUser.smartsubscribed);
        }
        let user = this.$store.getters.getUser;
        this.userData = this.$store.getters.getUser;
        this.userID = user.id;
        this.fetchInspectionRequests();
        this.fetchMaintainanceRequests();
        this.fetchManagementRequests();
        this.fetchFMIORequests();
        this.fetchFacilityDashboardSummary();
        this.fetchDashboardSummary();
        // this.fetchPropertiesRandomly();
        this.startAutoSlide();
        this.opportunityByCategory();
        this.partnersManagementPopUp();
    },  
    methods: {
        moveToPropertyManagement(tab) {
            localStorage.setItem("managementType", tab);
            this.$router.push({path: `/user/partner/property-management`});
        },
        reloadFunc() {
            this.fetchDashboardSummary();
        },
        async startCountdownPartnerPop() {
            this.intervalId = setInterval(() => {
                const now = Date.now();
                // this.timeLeft = ((this.countdownsmartUser) - now);
                // console.log("Prop smartUser1", this.timeLeftP)
                if(this.popupPartnersManagement) {
                    this.timeLeftP = ((this.popupPartnersManagement.timestamp * 1000) - now);
                    //  console.log("Prop smartUser2", this.timeLeftP)
                }

                if (this.timeLeftP <= 0) {
                clearInterval(this.intervalId);
                this.timeLeftP = 0;
                }
            }, 1000);
        },

        async startCountdownTop() {
            this.intervalId = setInterval(() => {
                const now = Date.now();
                // this.timeLeft = ((this.countdownTimestamp) - now);
                // console.log("Prop timestamp1", this.propertyRequest.timestamp)
                if(this.requestData.fmio) {
                    this.timeLeft = ((this.requestData.fmio.timestamp * 1000) - now);
                    // console.log("timeeeeee left", this.timeLeft)
                }

                if (this.timeLeft <= 0) {
                clearInterval(this.intervalId);
                this.timeLeft = 0;
                }
            }, 1000);
        },
        async startCountdownTop2() {
            this.intervalId = setInterval(() => {
                const now = Date.now();
                // this.timeLeft = ((this.countdownTimestamp) - now);
                // console.log("Prop timestamp1", this.propertyRequest.timestamp)
                if(this.requestData.propertyAssign) {
                    this.timeLeft2 = ((this.requestData.propertyAssign.timestamp * 1000) - now);
                    // console.log("timeeeeee left", this.timeLeft)
                }

                if (this.timeLeft2 <= 0) {
                clearInterval(this.intervalId);
                this.timeLeft2 = 0;
                }
            }, 1000);
        },
        async startCountdownTop3() {
            this.intervalId = setInterval(() => {
                const now = Date.now();
                // this.timeLeft = ((this.countdownTimestamp) - now);
                // console.log("Prop timestamp1", this.propertyRequest.timestamp)
                if(this.requestData.maintainance) {
                    this.timeLeft3 = ((this.requestData.maintainance.timestamp * 1000) - now);
                    // console.log("timeeeeee left", this.timeLeft)
                }

                if (this.timeLeft3 <= 0) {
                clearInterval(this.intervalId);
                this.timeLeft3 = 0;
                }
            }, 1000);
        },
        async partnersManagementPopUp() {
            try {
                await partners.partnerPropertyManagementRequests(this.userID).then(res => {
                    // console.log("response parnters", res);
                    if (res.success) {
                        this.popupPartnersManagement = res.single_partner_property_management_request;
                        this.partnersManagement = res.partner_property_management_request;
                        // this.partnersManagement = res.partner_property_management_request.map(item => ({
                        //     ...item,
                        //     remaining: ''  // 🔥 Initialize remaining so it's reactive
                        // }));
                        // this.startPartnersManagementCountdown();
                        this.startCountdownPartnerPop();
                    }
                    if (res.error) {
                        this.$toast.success(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            } finally {
                // console.log("closed")
            }
        },
        async respondToManagementAssignment(action, requestId, buttonKey) { 
            this.btnLoading[buttonKey] = true;
            this.actionTaken = action;
            // if(this.propertyRequest == null) {
            //     return this.$toast.error("No request assigned");
            // }
            // this.requestLoader = true;
            if (action == 'ignore') {
                this.requestLoader2 = true;
                this.requestLoader = false;
            }
            else {
                this.requestLoader = true;
                this.requestLoader2 = false;
            }
            const body = {
                id: requestId,
                action: action,
            }
            try {
                await partners.respondPartnersRequest(JSON.stringify(body)).then(res => {
                    // console.log("request rresponse")
                    this.requestLoader = false;
                    this.requestLoader2 = false;
                    this.btnLoading[buttonKey] = false;
                    this.requestId = "";
                    if(res.success) {
                        let msg;
                        if (action == 'accept') {
                            msg = "Request accepted"
                        }
                        else {
                            msg = "Request rejected"
                        }
                        this.$toast.success(`SUCCESS: ${msg}`);
                        this.partnersManagementPopUp();
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.requestId = "";
                    this.requestLoader = false;
                    this.requestLoader2 = false;
                    this.btnLoading[buttonKey] = false;
                });
            } finally {
                // console.log("closed")
            }
        },
        async respondToPropertyAssignment(action, requestId, buttonKey) { 
            this.btnLoading[buttonKey] = true;
            this.actionTaken = action;
            // if(this.propertyRequest == null) {
            //     return this.$toast.error("No request assigned");
            // }
            // this.requestLoader = true;
            if (action == 'ignore') {
                this.requestLoader2 = true;
                this.requestLoader = false;
            }
            else {
                this.requestLoader = true;
                this.requestLoader2 = false;
            }
            const body = {
                id: requestId,
                action: action,
            }
            try {
                await partners.respondRequest(JSON.stringify(body)).then(res => {
                    // console.log("request rresponse")
                    this.requestLoader = false;
                    this.requestLoader2 = false;
                    this.btnLoading[buttonKey] = false;
                    this.requestId = "";
                    if(res.success) {
                        let msg;
                        if (action == 'accept') {
                            msg = "Request accepted"
                        }
                        else {
                            msg = "Request rejected"
                        }
                        this.$toast.success(`SUCCESS: ${msg}`);
                        this.fetchInspectionRequests();
                        this.fetchMaintainanceRequests();
                        this.fetchManagementRequests();
                        this.fetchFMIORequests();
                        this.fetchFacilityDashboardSummary();
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.requestId = "";
                    this.requestLoader = false;
                    this.requestLoader2 = false;
                    this.btnLoading[buttonKey] = false;
                });
            } finally {
                // console.log("closed")
            }
        },
        // respond-to-property-management-request
        // respond-to-maintenance
        async responseToPropertyMaintainanceFMIO(action, requestId, buttonKey) {
            this.btnLoading[buttonKey] = true;
            this.actionTaken = action;
            // if(this.propertyRequest == null) {
            //     return this.$toast.error("No request assigned");
            // }
            // this.requestLoader = true;
            if (action == 'ignore') {
                this.requestLoader2 = true;
                this.requestLoader = false;
            }
            else {
                this.requestLoader = true;
                this.requestLoader2 = false;
            }
            const body = {
                id: requestId,
                action: action,
            }
            let url;
            if (this.requestOption === 3 || this.popmaintainancefmio == 1) {
                url =  `respond-to-maintenance`;
            } 
            if (this.requestOption === 4 || this.popmaintainancefmio == 2) {
                url = `respond-to-fm-request`;
            }
            try {
                await partners.respondToPropertyMaintainanceFMIORequest(JSON.stringify(body), url).then(res => {
                    // console.log("request rresponse")
                    this.btnLoading[buttonKey] = false;
                    this.requestLoader = false;
                    this.requestLoader2 = false;
                    this.requestId = "";
                    if(res.success) {
                        let msg;
                        if (action == 'accept') {
                            msg = "Request accepted"
                        }
                        else {
                            msg = "Request rejected"
                        }
                        this.$toast.success(`SUCCESS: ${msg}`);
                        this.fetchInspectionRequests();
                        this.fetchMaintainanceRequests();
                        this.fetchManagementRequests();
                        this.fetchFMIORequests();
                        this.fetchFacilityDashboardSummary();
                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.requestLoader = false;
                    this.requestLoader2 = false;
                    this.requestId = "";
                    this.btnLoading[buttonKey] = false;
                });
            } finally {
                // console.log("closed")
            }
        },
        startCountdown() {
            // this.updateCountdowns();
            this.updateCountdownInpection();
            this.timer = setInterval(this.updateCountdownInpection, 1000);
        },
        startManagementCountdown() {
            this.updateCountdownManagement();
            this.timer2 = setInterval(this.updateCountdownManagement, 1000);
        },
        startMaintainanceCountdown() {
            this.updateCountdownMaintainance();
            this.timer3 = setInterval(this.updateCountdownMaintainance, 1000);
        },
        startFMIOCountdown() {
            this.updateCountdownFMIO();
            this.timer4 = setInterval(this.updateCountdownFMIO, 1000);
        },
        startPartnersManagementCountdown() {
            this.updateCountdownPartnersManagement();
            this.timer4 = setInterval(this.updateCountdownPartnersManagement, 1000);
        },
        updateCountdownInpection() {
            const now = Date.now();
            this.inspectionList.forEach((item) => {
                const endTime = item.timestamp * 1000;
                const diff = endTime - now;

                if (diff > 0) {
                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                item.remaining = `${hours}h : ${minutes}m : ${seconds}s`;
                } else {
                  item.remaining = "0 : 0 : 0";
                }
            });
        },
        updateCountdownManagement() {
            const now = Date.now();
            this.managementList.forEach((item) => {
                const endTime = item.timestamp * 1000;
                const diff = endTime - now;

                if (diff > 0) {
                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                item.remaining = `${hours}h : ${minutes}m : ${seconds}s`;
                } else {
                  item.remaining = "0 : 0 : 0";
                }
            });
        },
        updateCountdownMaintainance() {
            const now = Date.now();
            this.maintainanceList.forEach((item) => {
                const endTime = item.timestamp * 1000;
                const diff = endTime - now;

                if (diff > 0) {
                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                item.remaining = `${hours}h : ${minutes}m : ${seconds}s`;
                } else {
                  item.remaining = "0 : 0 : 0";
                }
            });
        },
        updateCountdownFMIO() {
            const now = Date.now();
            this.FmIoList.forEach((item) => {
                const endTime = item.timestamp * 1000;
                const diff = endTime - now;

                if (diff > 0) {
                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                item.remaining = `${hours}h : ${minutes}m : ${seconds}s`;
                } else {
                  item.remaining = "0 : 0 : 0";
                }
            });
        },

        updateCountdownPartnersManagement() {
            const now = Date.now();
            this.partnersManagement.forEach((item) => {
                const endTime = item.timestamp * 1000;
                const diff = endTime - now;

                if (diff > 0) {
                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                item.remaining = `${hours}h : ${minutes}m : ${seconds}s`;
                } else {
                  item.remaining = "0 : 0 : 0";
                }
            });
        },
        moveToPropertyDetails(batch) {
            // console.log("Unit details")
            this.$router.push({path: `/user/partner/property-details/${batch}`});
        },
        moveToPropertyDetailsOppotunity(id) {
            this.$router.push({path: `/user/opportunity-property/${id}`});
        },
        fetchInspectionRequests() {
            this.loading = true;
            if(this.userID) {
                partners.propertyInspectionRequests(this.userID).then(res => {
                    // console.log("Inspections", res);
                    this.loading = false;
                    if (res.success) {
                        this.inspectionList = res.request.map(item => ({
                            ...item,
                            remaining: ''  // 🔥 Initialize remaining so it's reactive
                        }));
                        this.startCountdown();
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$toast.error("please check your network and refresh the page");
                })
            }
        },
        fetchMaintainanceRequests() {
            this.loading = true;
            if(this.userID) {
                partners.propertyMaintainanceRequests(this.userID).then(res => {
                    // console.log("Maintainace", res);
                    this.loading = false;
                    if (res.success) {
                        // this.maintainanceList = res.list;
                        this.maintainanceList = res.list.map(item => ({
                            ...item,
                            remaining: ''  // 🔥 Initialize remaining so it's reactive
                        }));
                        this.startMaintainanceCountdown();
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$toast.error("please check your network and refresh the page");
                })
            }
        },
        fetchManagementRequests() {
            this.loading = true;
            if(this.userID) {
                partners.propertyManagementRequests(this.userID).then(res => {
                    // console.log("management", res);
                    this.loading = false;
                    if (res.success) {
                        this.managementList = res.request.map(item => ({
                            ...item,
                            remaining: ''  // 🔥 Initialize remaining so it's reactive
                        }));
                        this.startManagementCountdown();
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$toast.error("please check your network and refresh the page");
                })
            }
        },
        fetchFMIORequests() {
            this.loading = true;
            if(this.userID) {
                partners.propertyFMIORequests(this.userID).then(res => {
                    // console.log("FMIO REQUEST", res);
                    this.loading = false;
                    if(res.success) {
                        this.FmIoList = res.fm_requests.map(item => ({
                            ...item,
                            remaining: ''  // 🔥 Initialize remaining so it's reactive
                        }));
                        this.startFMIOCountdown()
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$toast.error("please check your network and refresh the page");
                })
            }
        },
        async fetchFacilityDashboardSummary() {
            this.loading = true;
            if(this.userID != "" || this.userID != null) {
                this.loading = true;
                try {
                    await partners.facilityDasboard(this.userID).then((res) => {
                    // console.log("Response", res);
                    this.loading = false;
                    if(res.success) {
                        this.dashboardData = res;
                        // this.pendingTask = res.pending_task;
                        // this.performersData = res.performance;
                        // this.ongoingMaintainance = res.ongoing_maintainace;
                        // this.ongoingInspection = res.ongoing_inspection;
                        // const valuesArray = Object.values(this.performersData);
                        // this.series = valuesArray; // Update the chart dynamically
                        this.totalEarnings = res.total_eanrings;
                        this.recentActivities = res.recent_activities;
                        this.propertySingleRequest = res.single_property_request;
                        this.fmioRequest = res.single_fm_request;
                        this.maintainanceRequest = res.single_maintenace_request;
                        this.requestData['propertyAssign'] = res.single_property_request;
                        this.requestData['fmio'] = res.single_fm_request;
                        this.requestData['maintainance'] = res.single_maintenace_request;
                        this.startCountdownTop();
                        this.startCountdownTop2();
                        this.startCountdownTop3();
                        // this.openPopUp();
                    }
                    }).catch((err) => {
                        console.log(err);
                        this.loading = false;
                    });
                } finally {
                    // console.log("stoped");
                }
            }
        },
        async fetchDashboardSummary() {
            this.loadingDashboard = true;
            if(this.userData.id != "" || this.userData.id != null) {
                this.loadingDashboard = true;
                try {
                    await partners.dashboard(this.userData.id).then((res) => {
                    // console.log("Response33333333", res);
                    this.loadingDashboard = false;
                    this.dashboardDataGraph = res;
                    this.graphData = res.graph_data;
                    this.assingedFMArray = res.assingedFM;
                    const valuesArray = Object.values(this.graphData);
                    this.series = [
                        {
                            data: valuesArray, // Update the chart dynamically
                        },
                    ];
                    }).catch((err) => {
                        console.log(err);
                        this.loadingDashboard = false;
                    });
                } finally {
                    // console.log("stoped");
                }
            }
        },
        // async fetchPropertiesRandomly() {
        //     try {
        //         await properties.fetchForRent().then(res => {
        //             console.log("Property", res);
        //             if(res.success) {
        //                 // this.randomProperties = res.properties;
        //             }
        //         }).catch((err) => {
        //             console.log(err);
        //         });
        //     } finally {
        //         // console.log("closed")
        //     }
        // },
        async opportunityByCategory() {
                this.loading = true;
                this.oppid = this.$route.params.id;
               await opportunities.opportunityDeskByCategoryId('2').then(data => {
                    // console.log("Opportunitiescategories:", data);
                    this.loading = false;
                    if (data.success) {
                        this.randomProperties = data.data;
                    } else {
                        this.$toast.error(data.error);
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$toast.error("please check your network and refresh the page");
                });
            },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.propItem.length;
        },
        prevSlide() {
            this.currentIndex = (this.currentIndex - 1 + this.propItem.length) % this.propItem.length;
        },
        startAutoSlide() {
            this.interval = setInterval(this.nextSlide, 4000);
        },
        stopAutoSlide() {
            clearInterval(this.interval);
        },
        
    },
}
</script>


<style scoped lang="scss">
$asheGrey: #555C74;
$primary: #0033ea;
$white: #ffffff;
$yellow: #ffb100;
$sheltaBlack: #2B3352;
.overview-text {
    color: #2D3E50;
    font-family: Lato;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 20px;

}
.notifications-holder {
    margin-top: 20px;
    border: 1px solid #E9EAEB;
    border-radius: 12px;
    padding: 12px;
    background: #ffffff;
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
        color: #2B3352;
    }

}
.notifications {
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #2B3352;
    }
    p {
       
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        color: #555C74;
        text-align: right;
    }
}

.requests-holder {
    margin-top: 30px;
    border: 1px solid #E9EAEB;
    border-radius: 12px;
    padding: 10px;
    background: #ffffff;
}
.request-top-text {
    h6 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        color: #2B3352;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #555C74;
    }
}
.show-more {
    color: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
}

.request-list {
    padding: 12px 16px;
    border: 1px solid #E8E8E8;
    border-radius: 8px;
    margin-top: 20px;
}

.request-btns {
    overflow: auto;
    display: flex;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        color: #555C74;
        // background: #FAFAFA;
        background: #ececec;
        border: 1px solid #E9EAEB;
        outline: 0;
        box-shadow: none;
    }
    button:not(:last-child) {
        margin-right: 5px;
    }
}
.activeBtnRequest {
    background: #FFFFFF !important;
    border: 1px solid #D5D7DA !important; 
}

.right-request {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    h5, h6 {
        font-family: Lato;
        font-size: 14px;
        line-height: 20px;
    }
    h5 {
        font-weight: 600;
        color: #2B3352;

    }
    h6 {
        font-weight: 400;
        color: #555C74;

    }
    h4 {
        color: #FB3748;
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        line-height: 32px;
        span {
            color: #92400E;
            font-family: Lato;
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
        }
    }
}

.request-btns-acctions {
    margin-top: 30px;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        border-radius: 8px;
        color: #414651;
        background: transparent;
        outline: 0;
        box-shadow: none;
    }
    button:not(:last-child) {
        // margin-right: 10px;
        margin-right: 7px;
    }
}
.acceptBtn {
    border: 1px solid #1FC16B !important;
}
.viewBtn {
    border: 1px solid #0033EA !important;
}
.rejectBtn {
    border: 1px solid #FB3748 !important;
}


.card-body {
   border: 1px solid #E9EAEB;
   padding: 20px;
   border-radius: 10px;
   margin-top: 20px;
   background: #ffffff;
   h6 {
      font-family: Lato;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0%;

   }
   h3 {
      font-family: Lato;
      font-weight: 600;
      font-size: 30px;
      line-height: 38px;
      color: #2B3352;
   }
   p {
      font-family: Lato;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #555C74;
      position: relative;
      width: fit-content;

   }
   small {
      font-family: Lato;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #2B3352;
   }
}

.card-buttons {
   margin-top: 20px;
   button {
      margin-right: 10px;
      margin-bottom: 15px;
      outline: 0;
      box-shadow: none;
   }
}
.primary-btn {
   font-family: Lato;
   font-weight: 400;
   font-size: 14px;
   background: #0033EA;
   color: #ffffff;
   
}

.secondary-btn {
   font-family: Lato;
   font-weight: 400;
   font-size: 14px;
   border: 1px solid #D5D7DA;
   color: #414651;
}


.tooltip-text {
   visibility: hidden;
   width: 200px;
   background-color: #333;
   color: #fff;
   text-align: center;
   border-radius: 5px;
   padding: 5px 10px;
   position: absolute;
   z-index: 10;
   bottom: 125%; /* Position the tooltip above the element */
   left: 83px;
   transform: translateX(-50%);
   opacity: 0;
   transition: opacity 0.3s;
   text-align: left;
   // white-space: nowrap;
}

 /* Tooltip arrow */
 .tooltip-text::after {
   content: '';
   position: absolute;
   top: 100%;
   left: 50%;
   transform: translateX(-50%);
   border-width: 5px;
   border-style: solid;
   border-color: #333 transparent transparent transparent;
}

.info-icon {
   border: 1px solid #555C74;
   padding: 0px 6px;
   border-radius: 50px;
   margin-left: 2px;
   color: #555C74;
}


.tooltip-container {
   position: relative;
   // display: inline-block;
   cursor: pointer;
}


/* Show tooltip on hover */
.tooltip-container:hover .tooltip-text {
   visibility: visible;
   opacity: 1;
}


// For top popup starts

.pop-holder {
    background: #FFEDD6;
    padding: 16px;
    margin-bottom: 15px;
}

.left-hand {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: #2B3352;

    }
}

.time-bouund {
    display: flex;
    align-items: center;
    gap: 10px;
    h4 {
        width: fit-content;
        background: #ffffff;
        padding: 2px 12px;
        border-radius: 5px;
        font-family: Lato;
        font-weight: 700;
        font-size: 21px;
        line-height: 32px;
        color: #FB3748;
        display: flex;
        gap: 10px;
        white-space: nowrap;
        span {
            color: #92400E;
            font-size: 12px;
        }
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        color: #555C74;

    }
}


.responseButton {
    text-align: right;
    margin-top: 18px;
    button {
        min-height: 42px;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
    .accept {
        color: #ffffff;
        background: #0033EA;
        margin-right: 10px;
    }
    .reject {
        background: #ffffff;
        border: 1px solid #0033EA;
        color: #0033EA;
    }
}

@media screen and (max-width: 599px) {
    .time-bouund {
        display: block;
    }
    .responseButton {
        text-align: center;
    }
}
// For top popup ends


.earnings-task-holder {
    margin-bottom: 30px;
    border-radius: 10px;
}
.bar-chart-holder {
    margin-top: 20px;
    background: #ffffff;
    border-radius: 10px;
    padding: 24px;
    h4 {
        font-family: Inter;
        font-weight: 700;
        font-size: 19.18px;
        color: #222529;

    }
}
.task-holder {
    background: #ffffff;
    border-radius: 10px;
    padding: 24px 20px;
}

.task-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 21px;
        color: #2D3E50;
    }
    h6 {
        font-family: Lato;
        font-weight: 600;
        font-size: 11px;
        color: #0057FF;
        cursor: pointer;
    }
}


// Activity side 
.round-dot {
    width: 12px;
    height: 12px;
    background: #F99BAB;
    border-radius: 50px;
}

.task-buttons {
    button {
        border: 1px solid #0057FF;
        font-family: Lato;
        font-weight: 500;
        font-size: 13.16px;
        color: #0057FF;
        white-space: nowrap;
    }
}

.activity-holder {
    background: #ffffff;
    padding: 30px 16px;
    border-radius: 8px;
    margin-top: 20px;
}

.actiivity-buttons-holder {
    overflow: auto;
    display: flex;
    margin-bottom: 30px;
    button {
        font-family: Lato;
        // font-weight: 500;
        font-size: 16px;
        color: #555C74;
        box-shadow: none;
        outline: 0;
        white-space: nowrap;
    }

}
.activeBtn {
    background: #0033EA;
    border-radius: 50px;
    color: #ffffff !important;
    font-family: Lato;
    // font-weight: 600;
    font-size: 14px;

}

.tableList {
    // margin-top: 30px;
    margin-bottom: 20px;
    border: 2px solid #EAECF0;
    border-radius: 20px;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    background: #EAECF0;
}
thead th {
    white-space: nowrap;
    font-family: Lato;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    color: #667085
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #667085
}

.activeVoucher {
    font-family: Lato;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #067647;
    background: #ECFDF3;
    border-radius: 50px;
    padding: 4px 8px;
    // text-align: center;

}
.nonActiveVoucher {
    font-family: Lato;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    // text-align: center;
    color: #555C74;
    background: #FAFAFA;
    border-radius: 50px;
    padding: 4px 8px;
}

.input-field {
    height: 48px;
    outline: 0;
    box-shadow: none;
}

.search {
   width: 70%; 
}
// Activity side


.amount-address {
    display: flex;
    justify-content: space-between;
    gap: 19px;
    margin-bottom: 10px;
    p {
        font-family: Lato;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: #555C74;
    }
    h4 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 18px;
        color: #2B3352;

    }
}

.view-detail-btn {
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
}

.ellipsis {
  white-space: nowrap;        /* Keep text on a single line */
  overflow: hidden;           /* Hide any overflowing content */
  text-overflow: ellipsis;    /* Show '...' when text is cut off */
}

// carousel start here
.inner-carousel {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: auto;
    overflow: hidden;
}
.inner-slider {
   display: flex;
   transition: transform 0.5s ease;
}
.property-list {
    min-width: 100%;
    box-sizing: border-box;
    h6, p, h5 {
        font-family: Lato;
        font-size: 14px;
        line-height: 21px;
        text-align: left;
        color: #2B3352;
    }
    h6 {
        font-weight: 600;
    }
    p {
        font-weight: 400;
        color: $asheGrey;
        margin-bottom: 10px !important;
    }
    h5 {
        font-weight: 400;
        text-align: justified;
        color: $primary;
        span {
            font-weight: 600;
        }
    }
}

.slide-button {
    text-align: center;
    button {
        background: blue;
        width: 8px;
        height: 8px;
        border-radius: 50px;
        padding: inherit;
        margin: 0 5px;
    }
}

.active-slide {
    border: 4px solid $primary;
    padding: 3px !important;
    background: $white !important;
}
// Carousel ends here
</style>